import {Route} from '@angular/router';

export const error404Route: Route = {
    path: '404',
    loadChildren: () => import('./error-404.module').then(m => m.Error404Module)
};
